module.exports = __webpack_public_path__ + "img/result-bg-hen.801551b0.png";